
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 800 356","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"app-inline-svg",attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h147v39H0zM22 65h64v26H22zM94 105h47v13H94zM151 105h199v13H151z"}}),_c('circle',{attrs:{"cx":"79","cy":"111","r":"5"}}),_c('path',{attrs:{"d":"M94 131h47v13H94zM151 131h119v13H151z"}}),_c('circle',{attrs:{"cx":"79","cy":"137","r":"5"}}),_c('path',{attrs:{"d":"M94 157h47v13H94zM151 157h245v13H151z"}}),_c('circle',{attrs:{"cx":"79","cy":"163","r":"5"}}),_c('path',{attrs:{"d":"M22 196h64v26H22zM94 236h47v13H94zM151 236h230v13H151z"}}),_c('circle',{attrs:{"cx":"79","cy":"242","r":"5"}}),_c('path',{attrs:{"d":"M94 262h47v13H94zM151 262h302v13H151z"}}),_c('circle',{attrs:{"cx":"79","cy":"268","r":"5"}}),_c('path',{attrs:{"d":"M94 315h47v13H94zM151 315h230v13H151z"}}),_c('circle',{attrs:{"cx":"79","cy":"321","r":"5"}}),_c('path',{attrs:{"d":"M94 343h47v13H94zM151 343h199v13H151z"}}),_c('circle',{attrs:{"cx":"79","cy":"349","r":"5"}}),_c('path',{attrs:{"d":"M94 288h47v13H94zM151 288h151v13H151z"}}),_c('circle',{attrs:{"cx":"79","cy":"294","r":"5"}})])])
          )
        }
      }
    